type PlusIconProps = {
  color?: string;
  width?: number | string;
  height?: number | string;
  strokeWidth?: number | string;
};

const PlusIcon = ({ color = "#fff", width = 20, height = 20, strokeWidth = 4 }: PlusIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="12" y1="8.74231e-08" x2="12" y2="23" stroke={color} strokeWidth={strokeWidth} />
    <line x1="23" y1="11" x2="-1.74846e-07" y2="11" stroke={color} strokeWidth={strokeWidth} />
  </svg>
);

export default PlusIcon;
